import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {

  apiUrl! : string;
  constructor(private http: HttpClient, private environmentService: EnvironmentService)
  {
    this.apiUrl = this.environmentService.getConfig('BackendApi');
  }

  checkHealth(): Observable<string> {
    
    return this.http.get<string>(`${this.apiUrl}/api/health`, { responseType: 'json' });
  }
}
